import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const showAllStreams: AdminBlockTypeAttribute = {
  label: 'Show all streams',
  key: 'showAllStreams',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default showAllStreams;
